import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SnackBarUI from '../../comman/SnackBarUI'
import { deleteCategoryAction } from '../../redux/toolkit/category/deleteCategory'
import { getCategoryAction } from '../../redux/toolkit/category/getCategory'
import PropTypes from 'prop-types';

export default function DeleteCategory({ cat_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const deleteCategory = useSelector(state => state.deleteCategory)
    const { status, message } = deleteCategory

    const [snack, setSnack] = useState(false)

    // fn
    const handleClose = () => {
        setState(false)
    }

    const delCatHandle = async () => {
        await dispatch(deleteCategoryAction({ cat_id: cat_id }))
        await dispatch(getCategoryAction({ is_deleted: false }))
        setSnack(true)
        setState(false)
    }

    return (
        <>
            <Dialog open={state} onClose={handleClose}>
                <DialogTitle>Deleting request !</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the selected item ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={delCatHandle} autoFocus> Agree</Button>
                    <Button onClick={handleClose}>Disagree</Button>
                </DialogActions>
            </Dialog>


            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
        </>

    )
}



DeleteCategory.propTypes = {
    cat_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};
